import { FormProvider, useForm } from 'react-hook-form';
import { useAppSelector, useToast } from '../../../hooks';
import { Button } from '../../Button';
import { Input } from '../../Inputs/Input';
import { formRules } from '../FormRules';
import { useEffect, useState } from 'react';
import { apiService } from '../../../services/api';
import { UsersFormProps } from '../../../pages/Register/form-props.types';
import { UpdateUserReq, UserRole } from '../../../services/api.types';
import { useNavigate } from 'react-router-dom';
import { usersService } from '../../../services/users.service';

interface EmployeeFormValues {
  displayName: string;
  fullName: string;
  email: string;
  //notifySMS: boolean;
  notifyEmail: boolean;
  notifyWhatsapp: boolean;
  active?: boolean;
  role?: UserRole;
}

export function EmployeeRegisterForm({
  mode,
  userToUpdate,
}: Readonly<UsersFormProps>) {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const user = useAppSelector((state) => state.user);
  const selfEdit = userToUpdate?.id === user?.id;
  const navigate = useNavigate();

  const getEmployeeDefaultValues = (): EmployeeFormValues => {
    if (userToUpdate && mode === 'UPDATE') {
      return {
        displayName: userToUpdate.displayName,
        fullName: userToUpdate.fullName,
        email: userToUpdate.email,
        active: userToUpdate.active,
        role: userToUpdate.role,
        notifyEmail: userToUpdate.notifyEmail,
        notifyWhatsapp: userToUpdate.notifyWhatsapp,
      };
    }
    return {
      fullName: '',
      displayName: '',
      email: '',
      notifyEmail: true,
      notifyWhatsapp: true,
    };
  };

  const methods = useForm<EmployeeFormValues>({
    mode: 'all',
    defaultValues: getEmployeeDefaultValues(),
  });

  const fullName = methods.watch('fullName');
  useEffect(() => {
    if (mode === 'CREATE') {
      methods.setValue('displayName', fullName);
    }
  }, [fullName, mode, methods]);
  const onSubmit = async (data: EmployeeFormValues) => {
    setIsLoading(true);

    const updateAPImethod = (data: UpdateUserReq) =>
      userToUpdate && !selfEdit
        ? usersService.updateUserById(userToUpdate.id, data)
        : usersService.updateSelfUser(data);

    if (mode === 'UPDATE') {
      await updateAPImethod({
        displayName: data.displayName,
        fullName: data.fullName,
        email: data.email,
        notifyEmail: data.notifyEmail,
        notifyWhatsapp: data.notifyWhatsapp,
        active: data.active,
        role: data.role,
        [UserRole.EMPLOYEE]: {},
      })
        .then(() => {
          toast.success('Funcionário alterado!');
          navigate(-1);
        })
        .finally(() => {
          setIsLoading(false);
        });
      return;
    }
    if (mode === 'CREATE') {
      await apiService
        .registerEmployee({
          ...data,
        })
        .then(() => {
          methods.reset(getEmployeeDefaultValues());
          toast.success('Funcionário cadastrado!');
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="flex flex-col items-center gap-1 w-full box-border pt-2 p-4 justify-between"
      >
        <Input
          name="fullName"
          label="Nome Completo"
          rules={formRules.fullNameRequired}
        />
        <Input name="displayName" label="Como gostaria de ser chamado(a)?" />

        <Input
          name="email"
          type="email"
          label="E-mail"
          rules={formRules.emailRequired}
        />

        <Button
          className="mt-6"
          fullWidth
          type="submit"
          isLoading={isLoading}
          circular
        >
          {mode === 'CREATE' ? 'Cadastrar' : 'Alterar'}
        </Button>
      </form>
    </FormProvider>
  );
}
